import { BaseApiService } from '../../../api/base';
import type {
  ApplicationDraft,
  ApplicationState,
} from '../types/application';

class ApplicationApiService extends BaseApiService {
  async getLoanApplicationState(): Promise<ApplicationState> {
    return this.get<ApplicationState>('/wlc/loans/state');
  }

  async applyOffer(applicationDraft: ApplicationDraft): Promise<void> {
    return this.post(`/loans/offers/apply`, applicationDraft);
  }
}

export const applicationApiService = new ApplicationApiService();
